import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
	ILeapOnboardingService,
	LEAP_ONBOARDING_SERVICE,
} from '../../leap-onboarding.models';

@Component({
	selector: 'app-video-intro',
	templateUrl: './video-intro.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class VideoIntroComponent {
	private leapOnboardingService: ILeapOnboardingService = inject(
		LEAP_ONBOARDING_SERVICE,
	);

	goToConnectToCloserScreen() {
		this.leapOnboardingService.goToWelcomeScreen();
	}
}
